// import React from "react";
// import { Link } from "react-router-dom";
// import ContentHeader from "../../Components/ContentHeader/ContentHeader";
// import Loading from "../../Components/Loading/Loading";
// import CenFilters from "../../Components/CenFilters/CenFilters";

// function DashboardUi({
//   data,
//   loading,
//   setTableQaury,
//   selectData,
//   setFiltersId,
//   refetchStates,
//   refetchcity,
//   setSelectData,
//   filtersId,
//   applyFilter,
//   removeFilter,
//   decodedToken,
// }) {
//   return (
//     <div>
//       {" "}
//       {/* Content Wrapper. Contains page content */}
//       {loading ? (
//         <Loading />
//       ) : (
//         <div className="content-wrapper">
//           {/* Content Header (Page header) */}
//           <ContentHeader
//             title={"Dashboard"}
//             buttonName={""}
//             buttonBoolean={false}
//             pageName={"Dashboard"}
//             linkPath={""}
//           />
//           {/* /.content-header */}
//           {/* Main content */}
//           <section className="content vh-100">
//             <div className="container-fluid">
//               {/* Small boxes (Stat box) */}
//               <div className="row">
//                 <div className="col-lg-4 col-6">
//                   {/* small box */}
//                   <div className="small-box bg-info">
//                     <div className="inner">
//                       <h3>{data?.users ? data?.users : 0}</h3>
//                       <p>Total Auditors</p>
//                     </div>
//                     <div className="icon">
//                       <i className="ion ion-person-add" />
//                     </div>
//                   </div>
//                 </div>
//                 {/* ./col */}
//                 <div className="col-lg-4 col-6">
//                   {/* small box */}
//                   <div className="small-box bg-success">
//                     <div className="inner">
//                       <h3>{data?.centres ? data?.centres : 0}</h3>
//                       <p>Total Centers</p>
//                     </div>
//                     <div className="icon">
//                       <i className="ion ion-stats-bars" />
//                     </div>
//                   </div>
//                 </div>
//                 {/* ./col */}
//                 <div className="col-lg-4 col-6">
//                   {/* small box */}
//                   <div className="small-box bg-yellow">
//                     <div className="inner text-white">
//                       <h3>{data?.rrbs ? data?.rrbs  : 0}</h3>
//                       <p>Total RRBs</p>
//                     </div>
//                     <div className="icon">
//                       <i className="ion ion-pie-graph" />
//                     </div>
//                   </div>
//                 </div>

//                 {/* ./col */}
//               </div>
//               <div>
//                 <CenFilters
//                   selectData={selectData}
//                   setFiltersId={setFiltersId}
//                   refetchStates={refetchStates}
//                   refetchcity={refetchcity}
//                   setSelectData={setSelectData}
//                   filtersId={filtersId}
//                   applyFilter={applyFilter}
//                   removeFilter={removeFilter}
//                   decodedToken={decodedToken}
//                   showFilter={{
//                     rrb: true,
//                     state: true,
//                     city: true,
//                     center: false,
//                   }}
//                 />
//               </div>
//               <div className="row">
//                 <div className="col-lg-4 col-6">
//                   {/* small box */}
//                   <div className="small-box bg-yellow">
//                     <div className="inner text-white">
//                       <h3>{data?.in_progress_centres ? data?.in_progress_centres : 0}</h3>
//                       <p>Total In Progress Centres</p>
//                     </div>
//                     <div className="icon">
//                       <i className="ion ion-pie-graph" />
//                     </div>
//                   </div>
//                 </div>
//                 {/* ./col */}
//                 <div className="col-lg-4 col-6">
//                   {/* small box */}
//                   <div className="small-box bg-blue">
//                     <div className="inner">
//                       <h3>{data?.audited_centres ? data?.audited_centres : 0}</h3>
//                       <p>Total Audited Centres</p>
//                     </div>
//                     <div className="icon">
//                       <i className="ion ion-pie-graph" />
//                     </div>
//                   </div>
//                 </div>
//                 {/* ./col */}
//                 {/* ./col */}
//                 <div className="col-lg-4 col-6">
//                   {/* small box */}
//                   <div className="small-box bg-danger">
//                     <div className="inner">
//                       <h3>{data?.pending_centres ?  data?.pending_centres : 0}</h3>
//                       <p>Total Pending Centres</p>
//                     </div>
//                     <div className="icon">
//                       <i className="ion ion-pie-graph" />
//                     </div>
//                   </div>
//                 </div>
//                 {/* ./col */}
//               </div>

//               {/* /.row */}
//             </div>
//             {/* /.container-fluid */}
//           </section>
//           {/* /.content */}
//         </div>
//       )}
//     </div>
//   );
// }

// export default DashboardUi;

import React from "react";
import { Link, useNavigate } from "react-router-dom";
import ContentHeader from "../../Components/ContentHeader/ContentHeader";
import Loading from "../../Components/Loading/Loading";
import CenFilters from "../../Components/CenFilters/CenFilters";
import users from "../../assets/users.png";
import center from "../../assets/center.png";
import rrbs from "../../assets/rrbs.png";
import "./dashStyle.css";
import DashBoardFilters from "../../Components/DashBoardFilters/DashBoardFilters";
import warning from "../../assets/warning.png";
import clock from "../../assets/clock.png";
import check from "../../assets/check.png";
import close_icon from "../../assets/close.png";
import { Bar, Doughnut, Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Filler,
} from "chart.js";
import RrbDropdown from "../../Components/RRBDropdown/RrbDropdown";
import CanvasJSReact from "@canvasjs/react-charts";
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Filler
);
function DashboardUi({
  data,
  loading,
  setTableQaury,
  selectData,
  setFiltersId,
  refetchStates,
  refetchcity,
  setSelectData,
  filtersId,
  applyFilter,
  removeFilter,
  decodedToken,
  cenData,
  // areaChartData,
  // areaChartOptions
  setCenSearch,
  cenSearch,
  cenRefetch,
}) {
  const navigate = useNavigate();
  const doughnutChart = {
    labels: ["In Progress Center"],
    datasets: [
      {
        label: "Centers",
        data: [
          data?.in_progress_centres
            ? data?.in_progress_centres > 3
              ? data?.in_progress_centres
              : 3
            : 0,
          data?.centres ? data?.centres : 0,
        ],
        backgroundColor: ["#eab308", "#dcdcde"],
        borderColor: ["#eab308", "#dcdcde"],
        borderWidth: 0,
      },
    ],
  };

  const handleDataPointClick = (status) => {
    // const status = e.dataPoint.label;
    if (status === "In Progress") {
      navigate("/audits", { state: { status: "not-submitted" } });
    }
    if (status === "completed") {
      navigate("/audits", { state: { status: "submitted" } });
    }
    if (status === "pending") {
      navigate("/audits", { state: { status: "pending" } });
    }
    if (status === "pending_approval") {
      navigate("/audits", { state: { audit_status: "pending" } });
    }
    if (status === "approved") {
      navigate("/audits", { state: { audit_status: "approved" } });
    }
    if (status === "rejected") {
      navigate("/audits", { state: { audit_status: "rejected" } });
    }
    if (status === "partially_approved") {
      navigate("/audits", { state: { audit_status: "partially_approved" } });
    }
  };

  const options1 = {
    animationEnabled: true,
    width: 145,
    height: 150,
    subtitles: [
      {
        text: `${data?.in_progress_centres ?? "0"}`,
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
      },
    ],

    data: [
      {
        type: "doughnut",
        showInLegend: false,
        dataPoints: [
          { name: "Centers", y: data?.in_progress_centres, color: "#FACC3D" },
          {
            name: "Centers",
            y: data?.centres ? data?.centres - data?.in_progress_centres : 0,
            color: "#dcdcde",
          },
        ],
      },
    ],
  };

  const options2 = {
    animationEnabled: true,
    width: 145,
    height: 150,
    subtitles: [
      {
        text: `${data?.audited_centres ?? "0"}`,
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
      },
    ],

    data: [
      {
        type: "doughnut",
        showInLegend: false,
        dataPoints: [
          { name: "Centers", y: data?.audited_centres, color: "#3824C580" },
          {
            name: "Centers",
            y: data?.centres ? data?.centres - data?.audited_centres : 0,
            color: "#dcdcde",
          },
        ],
      },
    ],
  };

  const options3 = {
    animationEnabled: true,
    width: 145,
    height: 150,
    subtitles: [
      {
        text: `${data?.pending_centres ?? "0"}`,
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
      },
    ],

    data: [
      {
        type: "doughnut",
        showInLegend: false,
        dataPoints: [
          { name: "Centers", y: data?.pending_centres, color: "#E82B3580" },
          {
            name: "Centers",
            y: data?.centres ? data?.centres - data?.pending_centres : 0,
            color: "#dcdcde",
          },
        ],
      },
    ],
  };

  const options4 = {
    animationEnabled: true,
    width: 100,
    height: 150,
    subtitles: [
      {
        text: `${data?.pending_approval ?? "0"}`,
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
      },
    ],

    data: [
      {
        type: "doughnut",
        showInLegend: false,
        dataPoints: [
          { name: "Centers", y: data?.pending_approval, color: "#992cff" },
          {
            name: "Centers",
            y: data?.centres ? data?.centres - data?.pending_approval : 0,
            color: "#dcdcde",
          },
        ],
      },
    ],
  };

  const options5 = {
    animationEnabled: true,
    width: 100,
    height: 150,
    subtitles: [
      {
        text: `${data?.approved ?? "0"}`,
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
      },
    ],

    data: [
      {
        type: "doughnut",
        showInLegend: false,
        dataPoints: [
          { name: "Centers", y: data?.approved, color: "#008000" },
          {
            name: "Centers",
            y: data?.centres ? data?.centres - data?.approved : 0,
            color: "#dcdcde",
          },
        ],
      },
    ],
  };

  const options6 = {
    animationEnabled: true,
    width: 100,
    height: 150,
    subtitles: [
      {
        text: `${data?.conditional_approval ?? "0"}`,
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
      },
    ],

    data: [
      {
        type: "doughnut",
        showInLegend: false,
        dataPoints: [
          { name: "Centers", y: data?.conditional_approval, color: "#FFFF00" },
          {
            name: "Centers",
            y: data?.centres ? data?.centres - data?.conditional_approval : 0,
            color: "#dcdcde",
          },
        ],
      },
    ],
  };

  const options7 = {
    animationEnabled: true,
    width: 100,
    height: 150,
    subtitles: [
      {
        text: `${data?.rejected ?? "0"}`,
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
      },
    ],

    data: [
      {
        type: "doughnut",
        showInLegend: false,
        dataPoints: [
          { name: "Centers", y: data?.rejected, color: "#FF0000" },
          {
            name: "Centers",
            y: data?.centres ? data?.centres - data?.rejected : 0,
            color: "#dcdcde",
          },
        ],
      },
    ],
  };
  const totalCentres =
    (data?.audited_centres || 0) +
    (data?.in_progress_centres || 0) +
    (data?.pending_centres || 0);

  // Assuming `data` is the object containing the counts for each category
  const totalCentres2 =
    (data?.pending_approval || 0) +
    (data?.approved || 0) +
    (data?.conditional_approval || 0) +
    (data?.rejected || 0);

  const isNoData =
    !data?.audited_centres &&
    !data?.in_progress_centres &&
    !data?.pending_centres;

  // Check if all data points are zero or undefined
  const isNoData2 =
    !(data?.pending_approval || 0) &&
    !(data?.approved || 0) &&
    !(data?.conditional_approval || 0) &&
    !(data?.rejected || 0);

  const pieChartOption = {
    exportEnabled: false,
    animationEnabled: true,
    height: 250, // Set desired height
    width: 250, // Set desired width
    data: [
      {
        type: "pie",
        startAngle: 75,
        toolTipContent: `<b>{label}</b>: {y}%`,
        showInLegend: false,
        indexLabel: null, // Disable labels completely
        dataPoints: !isNoData
          ? [
              {
                y: parseFloat(
                  (((data?.audited_centres || 0) / totalCentres) * 100).toFixed(
                    2
                  )
                ),

                color: "#3824C580",
                click: () => handleDataPointClick("completed"),
              },
              {
                y: parseFloat(
                  (
                    ((data?.in_progress_centres || 0) / totalCentres) *
                    100
                  ).toFixed(2)
                ),

                color: "#FACC3D",
                click: () => handleDataPointClick("In Progress"),
              },
              {
                y: parseFloat(
                  (((data?.pending_centres || 0) / totalCentres) * 100).toFixed(
                    2
                  )
                ),

                color: "#E82B3580",
                click: () => handleDataPointClick("pending"),
              },
            ]
          : [],
      },
    ],
  };
  const pieChartOption2 = {
    exportEnabled: false,
    animationEnabled: true,
    height: 250, // Set desired height
    width: 250, // Set desired width
    data: [
      {
        type: "pie",
        startAngle: 75,
        toolTipContent: `<b>{label}</b>: {y}%`,
        showInLegend: false,
        dataPoints: !isNoData2
          ? [
              {
                y: parseFloat(
                  (
                    ((data?.pending_approval || 0) / totalCentres2) *
                    100
                  ).toFixed(2)
                ),

                color: "#992cff",
                click: () => handleDataPointClick("pending_approval"),
              },
              {
                y: parseFloat(
                  (((data?.approved || 0) / totalCentres2) * 100).toFixed(2)
                ),

                color: "#22c55e", // Green
                click: () => handleDataPointClick("approved"),
              },
              {
                y: parseFloat(
                  (
                    ((data?.conditional_approval || 0) / totalCentres2) *
                    100
                  ).toFixed(2)
                ),

                color: "#eab308", // Yellow
                click: () => handleDataPointClick("partially_approved"),
              },
              {
                y: parseFloat(
                  (((data?.rejected || 0) / totalCentres2) * 100).toFixed(2)
                ),

                color: "#FF0000", // Red
                click: () => handleDataPointClick("rejected"),
              },
            ].filter((dataPoint) => dataPoint.y > 0) // Filter out zero values
          : [],
      },
    ],
  };

  const handleSectionsClick = (data) => {
    navigate(`/${data}`);
  };

  const doughnutChart1 = {
    labels: ["Audited Centers"],
    datasets: [
      {
        label: "Centers",
        data: [
          data?.audited_centres
            ? data?.audited_centres > 3
              ? data?.audited_centres
              : 3
            : 0,
          data?.centres ? data?.centres : 0,
        ],
        backgroundColor: ["#3737c0", "#dcdcde"],
        borderColor: ["#3737c0", "#dcdcde"],
        borderWidth: 1,
      },
    ],
  };
  const doughnutChart2 = {
    labels: ["Pending Centers"],
    datasets: [
      {
        label: "Centers",
        data: [
          data?.pending_centres
            ? data?.pending_centres > 3
              ? data?.pending_centres
              : 3
            : 0,
          data?.centres ? data?.centres : 0,
        ],
        backgroundColor: ["#ff5733", "#dcdcde"],
        borderColor: ["#ff5733", "#dcdcde"],
        borderWidth: 1,
      },
    ],
  };
  // const options = {
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       display: false,
  //       position: "top",
  //     },
  //     tooltip: {
  //       enabled: false,
  //     },
  //   },
  // };

  // const areaChartData = {
  //   labels:[0, 5, 15, 20, 25, 17, 5],
  //   datasets: [
  //     {
  //       label: "Electronics",
  //       borderColor: "#eab308",
  //       pointRadius: false,
  //       data: [0, 5, 15, 20, 25, 17, 5],
  //       fill: true,
  //       backgroundColor: "#eab308",
  //       tension: 0.4,
  //     },
  //   ],
  // };
  // const areaChartData1 = {
  //   labels: ["January", "February", "March", "April", "May", "June", "July"],
  //   datasets: [
  //     {
  //       label: "Electronics",
  //       borderColor: "#3737c0",
  //       pointRadius: false,
  //       data: [0, 5, 15, 20, 25, 17, 5],
  //       fill: true,
  //       backgroundColor: "#3737c0",
  //       tension: 0.4,
  //     },
  //   ],
  // };
  // const areaChartData2 = {
  //   labels: ["January", "February", "March", "April", "May", "June", "July"],
  //   datasets: [
  //     {
  //       label: "Electronics",
  //       borderColor: "#EF4444",
  //       pointRadius: false,
  //       data: [0, 5, 15, 20, 25, 17, 5],
  //       fill: true,
  //       backgroundColor: "#EF4444",
  //       tension: 0.4,
  //     },
  //   ],
  // };

  // const areaChartOptions = {
  //   type: "line",
  //   maintainAspectRatio: false,
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       display: false,
  //     },
  //   },
  //   scales: {
  //     x: {
  //       grid: {
  //         display: false,
  //       },
  //       ticks: {
  //         display: false, // Hide X-axis labels
  //       },
  //     },
  //     y: {
  //       grid: {
  //         display: false,
  //       },
  //       ticks: {
  //         display: false, // Hide Y-axis labels
  //       },
  //     },
  //   },
  // };
  const barChatdata = {
    labels: [
      "Pending Approval",
      "Approved",
      "Conditional Approved",
      "Rejected",
    ],
    datasets: [
      {
        // label: "Pending Approval",
        borderWidth: 1,
        data: [
          data?.pending_approval ?? 0,
          data?.approved ?? 0,
          data?.conditional_approval ?? 0,
          data?.rejected ?? 0,
        ], // Data for first dataset
        backgroundColor: ["#A855F7", "#22C55E", "#EAB308", "#EF4444"], // Bar colors for each label
        borderColor: ["#A855F7", "#22C55E", "#EAB308", "#EF4444"],
      },
      // {
      //   label: 'Approved',
      //   data: [892], // Data for Product B
      //   backgroundColor: '#eab308', // Bar color for Product B
      //   borderColor: '#eab308',
      //   borderWidth: 1,
      // },
      // {
      //   label: 'Conditional Approved',
      //   data: [234], // Data for Product C
      //   backgroundColor: '#ff5733', // Bar color for Product C
      //   borderColor: '#ff5733',
      //   borderWidth: 1,
      // },
      // {
      //   label: 'Rejected',
      //   data: [89], // Data for Product C
      //   backgroundColor: '#ff5733', // Bar color for Product C
      //   borderColor: '#ff5733',
      //   borderWidth: 1,
      // },
    ],
  };
  const barChartoptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: "Monthly Sales Data",
      },
      tooltip: {
        enabled: true, // Disable tooltips if needed
      },
    },
  };

  const piedata = {
    labels: ["Audited", "In Progress", "Pending"],
    datasets: [
      {
        label: "Colors",
        // data: [
        //   data?.audited_centres ? data?.audited_centres : 0,
        //   data?.in_progress_centres ? data?.in_progress_centres : 0,
        //   data?.pending_centres ? data?.pending_centres : 0,
        // ],
        data: !isNoData
          ? [
              ((data?.audited_centres || 0) / totalCentres) * 100,
              ((data?.in_progress_centres || 0) / totalCentres) * 100,
              ((data?.pending_centres || 0) / totalCentres) * 100,
            ]
          : [0, 0, 0],
        backgroundColor: ["#3737c0", "#eab308", "#EF4444"],
        borderColor: ["#3737c0", "#eab308", "#EF4444"],
        borderWidth: 1,
      },
    ],
  };
  const piedata2 = {
    labels: ["Total Auditors", "Total Centers", "Total RRBs"],
    datasets: [
      {
        label: "Colors",
        data: [
          data?.users ? data?.users : 0,
          data?.centres ? data?.centres : 0,
          data?.rrbs ? data?.rrbs : 0,
        ],
        backgroundColor: ["black", "#22c55e", "#eab308"],
        borderColor: ["black", "#22c55e", "#eab308"],
        borderWidth: 1,
      },
    ],
  };
  const pieoptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
    },
  };
  return (
    <div>
      {/* Content Wrapper. Contains page content */}
      {loading ? (
        <Loading />
      ) : (
        <div className="content-wrapper dashboard-main">
          {/* Content Header (Page header) */}
          <div className="dash-header">
            <ContentHeader
              title={"Dashboard"}
              buttonName={""}
              buttonBoolean={false}
              pageName={"Dashboard"}
              linkPath={""}
              decodedToken={decodedToken}
            />
          </div>
          {/* /.content-header */}
          {/* Main content */}
          <section className="content  mt-4 dashboard">
            <div className="container-fluid">
              {/* Small boxes (Stat box) */}

              <div className="row">
                <div
                  className={`${
                    decodedToken?.role == 3 || decodedToken?.role == 4
                      ? "col-lg-3 col-6"
                      : "col-lg-4 col-6"
                  } cursor-pointer`}
                  {...(decodedToken?.role == 3 || decodedToken?.role == 4
                    ? { onClick: () => handleSectionsClick("cen") }
                    : {})}
                >
                  {/* small box */}
                  <div className="dash-card d-flex">
                    <div className="dash-icon-box icon-box-2">
                      <img src={center} alt="" />
                    </div>
                    <div className="ml-3">
                      <p className="dash-head2-label">Total CEN (Exams)</p>
                      <h5 className="dash-head2-value">
                        {data?.cen_counts ? data?.cen_counts : 0}
                      </h5>
                    </div>
                  </div>
                </div>

                {decodedToken?.role == 3 || decodedToken?.role == 4 ? (
                  <div
                    className="col-lg-3 col-4 cursor-pointer"
                    onClick={() => handleSectionsClick("master-data/rrb")}
                  >
                    {/* small box */}
                    <div className="dash-card d-flex">
                      <div className="dash-icon-box icon-box-3">
                        <img src={rrbs} alt="" />
                      </div>
                      <div className="ml-3">
                        <p className="dash-head2-label">Total RRBs</p>
                        <h5 className="dash-head2-value">
                          {data?.rrbs ? data?.rrbs : 0}
                        </h5>
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* ./col */}
                <div
                  className={`${
                    decodedToken?.role == 3 || decodedToken?.role == 4
                      ? "col-lg-3 col-6"
                      : "col-lg-4 col-6"
                  } cursor-pointer`}
                  onClick={() => handleSectionsClick("master-data/centre")}
                >
                  {/* small box */}
                  <div className="dash-card d-flex">
                    <div className="dash-icon-box dash-icon-box2">
                      <img src={center} alt="" />
                    </div>
                    <div className="ml-3">
                      <p className="dash-head2-label">Total Centers</p>
                      <h5 className="dash-head2-value">
                        {data?.centres ? data?.centres : 0}
                      </h5>
                    </div>
                  </div>
                </div>
                {/* ./col */}
                <div
                  className={`${
                    decodedToken?.role == 3 || decodedToken?.role == 4
                      ? "col-lg-3 col-6"
                      : "col-lg-4 col-6"
                  } cursor-pointer`}
                  onClick={() => handleSectionsClick("auditors")}
                >
                  {/* small box */}
                  <div className="dash-card d-flex">
                    <div className="dash-icon-box icon-box-1">
                      <img src={users} alt="" />
                    </div>
                    <div className="ml-3">
                      <p className="dash-head2-label">Total Auditors</p>
                      <h5 className="dash-head2-value">
                        {data?.users ? data?.users : 0}
                      </h5>
                    </div>
                  </div>
                </div>
                {/* ./col */}
              </div>

              <div className="row mt-4">
                {/* <div className="col-4">
                  <div className="dash-card dash-card-chart chart-1">
                    <h6 className=" chart-heading">In Progress Center</h6>
                    <h3>
                      {data?.in_progress_centres
                        ? data?.in_progress_centres
                        : 0}
                    </h3>
                    <p className="chart-small-text">Total center in progress</p>
                    <div
                      className="chart-container d-flex justify-content-center"
                      style={{ height: "180px" }}
                    >
                      <Doughnut data={doughnutChart} options={options} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-6">
                  <div className="dash-card dash-card-chart chart-2">
                    <h6 className=" chart-heading">Completed Center</h6>
                    <h3>{data?.audited_centres ? data?.audited_centres : 0}</h3>
                    <p className="chart-small-text">Total completed center</p>
                    <div
                      className="chart-container d-flex justify-content-center"
                      style={{ height: "180px" }}
                    >
                      <Doughnut data={doughnutChart1} options={options} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-6">
                  <div className="dash-card dash-card-chart chart-3">
                    <h6 className=" chart-heading">Pending Center</h6>
                    <h3>{data?.pending_centres ? data?.pending_centres : 0}</h3>
                    <p className="chart-small-text">Total pending center</p>
                    <div
                      className="chart-container d-flex justify-content-center"
                      style={{ height: "180px" }}
                    >
                      <Doughnut data={doughnutChart2} options={options} />
                    </div>
                  </div>
                </div> */}
                {cenData && cenData?.length > 0 ? (
                  <>
                    <div className="col-lg-8">
                      <div className="dash-card">
                        <div
                          className="mb-3 d-flex align-items-center"
                          style={{ gap: "20px" }}
                        >
                          <DashBoardFilters
                            data={data}
                            cenData={cenData}
                            setFiltersId={setFiltersId}
                            refetchStates={refetchStates}
                            refetchcity={refetchcity}
                            setSelectData={setSelectData}
                            filtersId={filtersId}
                            applyFilter={applyFilter}
                            // removeFilter={removeFilter}
                            decodedToken={decodedToken}
                            showFilter={{
                              cen: false,
                              button: false,
                            }}
                            setCenSearch={setCenSearch}
                            cenSearch={cenSearch}
                            cenRefetch={cenRefetch}
                          />
                          {(decodedToken?.role == 3 ||
                            decodedToken?.role == 4) && (
                            <RrbDropdown
                              selectData={selectData}
                              setFiltersId={setFiltersId}
                              setSelectData={setSelectData}
                              filtersId={filtersId}
                              removeFilter={removeFilter}
                              decodedToken={decodedToken}
                              showFilter={{
                                rrb: true,
                              }}
                            />
                          )}
                        </div>
                        <div
                          className="d-flex justify-content-between"
                          style={{ padding: "0px 20px 0px 5px", width: "100%" }}
                        >
                          <div
                            className="chart-1"
                            onClick={() => handleDataPointClick("In Progress")}
                          >
                            <CanvasJSChart options={options1} />
                            <h6 className="chart-heading">
                              In Progress Center
                            </h6>
                            <p className="chart-small-text">
                              Total center in progress
                            </p>
                          </div>

                          <div
                            className="chart-2"
                            onClick={() => handleDataPointClick("completed")}
                          >
                            <CanvasJSChart options={options2} />
                            <h6 className="chart-heading">Completed Center</h6>
                            <p className="chart-small-text">
                              Total completed center
                            </p>
                          </div>

                          <div
                            className="chart-3"
                            onClick={() => handleDataPointClick("pending")}
                          >
                            <CanvasJSChart options={options3} />
                            <h6
                              className=" chart-heading"
                              style={{ padding: "0px 10px" }}
                            >
                              Pending Center
                            </h6>
                            <p className="chart-small-text ">
                              Total pending center
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="dash-card pie-container-chart">
                        {/* Display percentages for all categories */}
                        <div style={{ fontSize: "12px", lineHeight: "1.5" }}>
                          <div
                            style={{
                              display: "flex",
                              gap: "5px",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "20px",
                                height: "10px",
                                backgroundColor: "#3824C580",
                              }}
                            ></div>
                            <strong>Completed:</strong>{" "}
                            {(
                              ((data?.audited_centres || 0) /
                                (totalCentres || 1)) *
                              100
                            ).toFixed(2)}
                            %
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "5px",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "20px",
                                height: "10px",
                                backgroundColor: "#FACC3D",
                              }}
                            ></div>
                            <strong>In Progress:</strong>{" "}
                            {(
                              ((data?.in_progress_centres || 0) /
                                (totalCentres || 1)) *
                              100
                            ).toFixed(2)}
                            %
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "5px",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "20px",
                                height: "10px",
                                backgroundColor: "#E82B3580",
                              }}
                            ></div>
                            <strong>Pending:</strong>{" "}
                            {(
                              ((data?.pending_centres || 0) /
                                (totalCentres || 1)) *
                              100
                            ).toFixed(2)}
                            %
                          </div>
                        </div>
                        {isNoData ? (
                          <div className="no-data-message">
                            No Data Available
                          </div>
                        ) : (
                          <CanvasJSChart options={pieChartOption} />
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-lg-12">
                    <div className="dash-card">
                      <div className="d-flex align-items-center justify-content-center">
                        <div>
                          <p className="mb-0 text-center not-cen-text">
                            Currently, no CEN (Exam) number is available.
                          </p>
                          <p className="mb-0 text-center not-cen-text">
                            Kindly add the CEN number by clicking the button
                            below.
                          </p>
                          <div
                            className={`d-flex justify-content-center align-items-start mt-1`}
                            style={{ minWidth: "130px" }}
                          >
                            <>
                              {decodedToken?.role == 3 ||
                              decodedToken?.role == 4 ? (
                                <Link to="/cen" state={{ showModal: true }}>
                                  <button className="blue-btn mt-0 ">
                                    Add CEN
                                  </button>
                                </Link>
                              ) : null}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="row mt-4">
                {/* <div className="col-4">
                  <div className="dash-card dash-card-chart chart-1">
                    <h6 className=" chart-heading">In Progress Center</h6>
                    <h3>
                      {data?.in_progress_centres
                        ? data?.in_progress_centres
                        : 0}
                    </h3>
                    <p className="chart-small-text">Total center in progress</p>
                    <div
                      className="chart-container d-flex justify-content-center"
                      style={{ height: "180px" }}
                    >
                      <Doughnut data={doughnutChart} options={options} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-6">
                  <div className="dash-card dash-card-chart chart-2">
                    <h6 className=" chart-heading">Completed Center</h6>
                    <h3>{data?.audited_centres ? data?.audited_centres : 0}</h3>
                    <p className="chart-small-text">Total completed center</p>
                    <div
                      className="chart-container d-flex justify-content-center"
                      style={{ height: "180px" }}
                    >
                      <Doughnut data={doughnutChart1} options={options} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-6">
                  <div className="dash-card dash-card-chart chart-3">
                    <h6 className=" chart-heading">Pending Center</h6>
                    <h3>{data?.pending_centres ? data?.pending_centres : 0}</h3>
                    <p className="chart-small-text">Total pending center</p>
                    <div
                      className="chart-container d-flex justify-content-center"
                      style={{ height: "180px" }}
                    >
                      <Doughnut data={doughnutChart2} options={options} />
                    </div>
                  </div>
                </div> */}
                <div className="col-lg-8">
                  <div className="dash-card">
                    <h4>Approval Status Distribution</h4>
                    <div
                      className="d-flex justify-content-between"
                      style={{
                        padding: "0px 20px 0px 5px",
                        width: "100%",
                        marginTop: "60px",
                      }}
                    >
                      <div
                        className="chart-1"
                        onClick={() => handleDataPointClick("pending_approval")}
                      >
                        <CanvasJSChart options={options4} />
                        <h6
                          className="chart-heading"
                          style={{
                            padding: "0px 10px",
                            width: "20%",
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          Pending Approval
                        </h6>
                        {/* <p className="chart-small-text">
                              Total center in progress
                            </p> */}
                      </div>

                      <div
                        className="chart-2"
                        onClick={() => handleDataPointClick("approved")}
                      >
                        <CanvasJSChart options={options5} />
                        <h6
                          className="chart-heading"
                          style={{ marginLeft: "15px", fontSize: "16px" }}
                        >
                          Approved
                        </h6>
                        {/* <p className="chart-small-text">
                              Total completed center
                            </p> */}
                      </div>

                      <div
                        className="chart-3 "
                        onClick={() =>
                          handleDataPointClick("partially_approved")
                        }
                        style={{ marginLeft: "80px", textAlign: "center" }}
                      >
                        <CanvasJSChart options={options6} />
                        <h6
                          className=" chart-heading"
                          style={{
                            padding: "0px 10px",
                            width: "20%",
                            fontSize: "16px",
                            textAlign: "center",
                          }}
                        >
                          Conditional Approval
                        </h6>
                        {/* <p className="chart-small-text ">
                              Total pending center
                            </p> */}
                      </div>
                      <div
                        className="chart-4"
                        style={{ marginRight: "20px" }}
                        onClick={() => handleDataPointClick("rejected")}
                      >
                        <CanvasJSChart options={options7} />
                        <h6
                          className=" chart-heading"
                          style={{
                            padding: "0px 10px",
                            marginLeft: "10px",
                            fontSize: "16px",
                          }}
                        >
                          Rejected
                        </h6>
                        {/* <p className="chart-small-text ">
                              Total pending center
                            </p> */}
                      </div>
                      {/* <div className="chart-1">
                        <div
                          className="chart-container d-flex justify-content-center"
                        >
                          <Doughnut data={doughnutChart} options={options} />
                          <div className="chart-value-count">
                            {data?.in_progress_centres ?? 0}
                          </div>
                        </div>
                        <h6 className="chart-heading">In Progress Center</h6>
                        <p className="chart-small-text">Total center in progress</p>
                      </div> */}

                      {/* <div className="chart-2">
                        <div
                          className="chart-container d-flex justify-content-center"
                        >
                          <Doughnut data={doughnutChart1} options={options} />
                          <div className="chart-value-count">
                            {data?.audited_centres ?? 0}
                          </div>
                        </div>
                        <h6 className="chart-heading">Completed Center</h6>
                        <p className="chart-small-text">Total completed center</p>
                      </div>

                      <div className="chart-3">
                        <div
                          className="chart-container d-flex justify-content-center"
                        >
                          <Doughnut data={doughnutChart2} options={options} />
                          <div className="chart-value-count">
                            {data?.pending_centres ?? 0}
                          </div>
                        </div>
                        <h6 className=" chart-heading">Pending Center</h6>
                        <p className="chart-small-text">Total pending center</p>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div
                  className="dash-card pie-container-chart"
                  style={{ width: "31%", marginLeft: "14px" }}
                >
                  {/* Display percentages for all categories */}
                  <div style={{ fontSize: "12px", lineHeight: "1.5" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "20px",
                          height: "10px",
                          backgroundColor: "#992cff",
                        }}
                      ></div>
                      <strong>Pending Approval:</strong>{" "}
                      {(
                        ((data?.pending_approval || 0) / (totalCentres2 || 1)) *
                        100
                      ).toFixed(2)}
                      %
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "20px",
                          height: "10px",
                          backgroundColor: "#22c55e",
                        }}
                      ></div>
                      <strong>Approved:</strong>{" "}
                      {(
                        ((data?.approved || 0) / (totalCentres2 || 1)) *
                        100
                      ).toFixed(2)}
                      %
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "20px",
                          height: "10px",
                          backgroundColor: "#eab308",
                        }}
                      ></div>
                      <strong>Conditional Approval:</strong>{" "}
                      {(
                        ((data?.conditional_approval || 0) /
                          (totalCentres2 || 1)) *
                        100
                      ).toFixed(2)}
                      %
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "20px",
                          height: "10px",
                          backgroundColor: "#FF0000",
                        }}
                      ></div>
                      <strong>Rejected:</strong>{" "}
                      {(
                        ((data?.rejected || 0) / (totalCentres2 || 1)) *
                        100
                      ).toFixed(2)}
                      %
                    </div>
                  </div>
                  {isNoData ? (
                    <div className="no-data-message">No Data Available</div>
                  ) : (
                    <div className="canvasjs-chart-container">
                      <CanvasJSChart options={pieChartOption2} />
                    </div>
                  )}
                </div>
              </div>

              {/* <div className="row mt-4">
                <div className="col-lg-3 col-3">
                
                  <div className="dash-card1 d-flex">
                    <div className="dash-icon-box2 ">
                      <img src={clock} alt="" />
                    </div>
                    <div className="ml-3">
                      <p className="dash-box2-head2-label">Pending Approval</p>
                      <h5 className="dash-box2-head2-value">
                        {data?.pending_approval ?? 0}
                      </h5>
                    </div>
                  </div>
                </div>
              
                <div className="col-lg-3 col-3">
                  
                  <div className="dash-card1 d-flex">
                    <div className="dash-icon-box3 ">
                      <img src={check} alt="" />
                    </div>
                    <div className="ml-3">
                      <p className="dash-box2-head2-label">Approved</p>
                      <h5 className="dash-box2-head2-value">
                        {data?.approved ?? 0}
                      </h5>
                    </div>
                  </div>
                </div>
               
                <div className="col-lg-3 col-3">
                 
                  <div className="dash-card1 d-flex">
                    <div className="dash-icon-box4 ">
                      <img src={warning} alt="" />
                    </div>
                    <div className="ml-3">
                      <p className="dash-box2-head2-label">
                        Conditional Approval
                      </p>
                      <h5 className="dash-box2-head2-value">
                        {data?.conditional_approval ?? 0}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-3">
                 
                  <div className="dash-card1 d-flex">
                    <div className="dash-icon-box5 ">
                      <img src={close_icon} alt="" />
                    </div>
                    <div className="ml-3">
                      <p className="dash-box2-head2-label">Rejected</p>
                      <h5 className="dash-box2-head2-value">
                        {data?.rejected ?? 0}
                      </h5>
                    </div>
                  </div>
                </div>
              
              </div> */}

              {/* <div className="row mt-4">
                <div className="col-12">
                  <div className="dash-card dash-card-chart chart-1 chart-box-height">
                    <h6
                      className="chart-heading"
                      style={{ textAlign: "start" }}
                    >
                      Approval Status Distribution
                    </h6>
                    <div
                      className="chart-container"
                      style={{ height: "256px" }}
                    >
                      <Bar
                        data={barChatdata}
                        options={barChartoptions}
                        style={{ height: "256px" }}
                      />
                    </div>
                  </div>
                </div>
               
             
              </div> */}
            </div>
          </section>
        </div>
      )}
    </div>
  );
}

export default DashboardUi;
